var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BBadge',_vm._g(_vm._b({attrs:{"variant":_vm.variant}},'BBadge',_vm.$props,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.status === 'IN_PROGRESS')?_c('BSpinner',{attrs:{"size":"xxs"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }